// Module
var code = "<div><h1 class=\"page-title\">Prescription Key Management</h1><button class=\"btn btn-success\" style=\"margin-left:15px\" ng-click=\"vm.createKey()\" ng-disabled=\"!vm.isDoctor\" ng-if=\"!vm.rxKey\">Create Signature Key</button><button class=\"btn btn-success\" style=\"margin-left:15px\" ng-click=\"vm.createKey()\" ng-if=\"vm.rxKey\">Regenerate Signature Key </button></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/settings/prescription-key/prescription-key.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;